import Debug from '../../node_modules/debug/src/browser.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
const LogLevel = {
    none: '-',
    all: '*',
    error: 'error',
    info: 'info',
    debug: 'debug',
    warning: 'warning',
};
class Log {
    constructor(workspace = '') {
        this.init = (level) => {
            let namespaces = Debug.disable();
            const newEnable = `${this.workspace}${level}`;
            if (namespaces) {
                namespaces = namespaces.split(',').filter((lev) => !lev.startsWith(this.workspace));
            }
            Debug.enable(namespaces ? `${namespaces},${newEnable}` : newEnable);
        };
        this.error = (formatter, ...args) => {
            Debug(this.workspace + LogLevel.error)(formatter, ...args);
        };
        this.info = (formatter, ...args) => {
            Debug(this.workspace + LogLevel.info)(formatter, ...args);
        };
        this.debug = (formatter, ...args) => {
            Debug(this.workspace + LogLevel.debug)(formatter, ...args);
        };
        this.warn = (formatter, ...args) => {
            Debug(this.workspace + LogLevel.warning)(formatter, ...args);
        };
        this.workspace = `${workspace}-`;
    }
}
Log.LogLevel = LogLevel;

export { Log as default };
